import { createContext, useContext } from 'react';

export const FocusOnContext = createContext(false);

export const useFocusOnContext = () => useContext(FocusOnContext);
